import { APIError } from "../../api-error.js";
import { redactValue } from "../../../utils/redaction.js";
let apiErrorReporter;
export const setApiErrorReporter = (reporter) => {
    apiErrorReporter = reporter;
};
export const errorHandlerMiddleware = {
    async onResponse({ response, request }) {
        if (!response.ok) {
            let errorBody;
            try {
                errorBody = await response.clone().json();
            }
            catch {
                errorBody = await response.clone().text();
            }
            // Validation errors echo submitted fields, so the body is scrubbed once
            // here and every consumer, including the host's error reporter, sees the
            // redacted copy.
            const error = new APIError({
                endpoint: new URL(request.url).pathname,
                method: request.method,
                response: redactValue(errorBody),
                statusCode: response.status,
            });
            apiErrorReporter?.(error);
            throw error;
        }
        return response;
    },
};
